/**
 * Desktop push notification service (T114).
 *
 * Thin wrapper that imports the shared push service factory and passes
 * the desktop API client's fetch function.
 */

import { api } from './api';
import { createPushService, urlBase64ToUint8Array } from '@shared/push/service';

export type { PushService } from '@shared/push/service';
export type {
  VapidKeyResponse,
  PushSubscriptionResponse,
  PushSubscribeRequest,
  NotificationPreference,
  UnsubscribeResponse,
} from '@shared/push/types';
export { NotificationCategory } from '@shared/push/types';

/**
 * Adapter: convert desktop api.get/api.post/api.put to the generic ApiFetch shape.
 */
async function apiFetch(path: string, init?: { method?: string; body?: unknown }): Promise<unknown> {
  const method = init?.method ?? 'GET';
  switch (method) {
    case 'POST':
      return api.post(path, init?.body);
    case 'PUT':
      return api.put(path, init?.body);
    default:
      return api.get(path);
  }
}

export const pushService = createPushService(apiFetch);

export { urlBase64ToUint8Array };
